/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaEvaluateDebugExecutionProfile } from './FormulaEvaluateDebugExecutionProfile';
import {
    FormulaEvaluateDebugExecutionProfileFromJSON,
    FormulaEvaluateDebugExecutionProfileFromJSONTyped,
    FormulaEvaluateDebugExecutionProfileToJSON,
    FormulaEvaluateDebugExecutionProfileToJSONTyped,
} from './FormulaEvaluateDebugExecutionProfile';
import type { FormulaEvaluateMessage } from './FormulaEvaluateMessage';
import {
    FormulaEvaluateMessageFromJSON,
    FormulaEvaluateMessageFromJSONTyped,
    FormulaEvaluateMessageToJSON,
    FormulaEvaluateMessageToJSONTyped,
} from './FormulaEvaluateMessage';

/**
 * 
 * @export
 * @interface FormulaEvaluateDebugInfo
 */
export interface FormulaEvaluateDebugInfo {
    /**
     * 
     */
    executionProfile?: Array<FormulaEvaluateDebugExecutionProfile>;
    /**
     * 
     */
    messages?: Array<FormulaEvaluateMessage>;
}

/**
 * Check if a given object implements the FormulaEvaluateDebugInfo interface.
 */
export function instanceOfFormulaEvaluateDebugInfo(value: object): value is FormulaEvaluateDebugInfo {
    return true;
}

export function FormulaEvaluateDebugInfoFromJSON(json: any): FormulaEvaluateDebugInfo {
    return FormulaEvaluateDebugInfoFromJSONTyped(json, false);
}

export function FormulaEvaluateDebugInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateDebugInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'executionProfile': json['executionProfile'] == null ? undefined : ((json['executionProfile'] as Array<any>).map(FormulaEvaluateDebugExecutionProfileFromJSON)),
        'messages': json['messages'] == null ? undefined : ((json['messages'] as Array<any>).map(FormulaEvaluateMessageFromJSON)),
    };
}

export function FormulaEvaluateDebugInfoToJSON(json: any): FormulaEvaluateDebugInfo {
    return FormulaEvaluateDebugInfoToJSONTyped(json, false);
}

export function FormulaEvaluateDebugInfoToJSONTyped(value?: FormulaEvaluateDebugInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'executionProfile': value['executionProfile'] == null ? undefined : ((value['executionProfile'] as Array<any>).map(FormulaEvaluateDebugExecutionProfileToJSON)),
        'messages': value['messages'] == null ? undefined : ((value['messages'] as Array<any>).map(FormulaEvaluateMessageToJSON)),
    };
}

